import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const services = [
  {
    title: "Rope Access / Work at Height",
    description:
      "Specialist access support for tasks where conventional access methods are limited, inefficient or disruptive.",
  },
  {
    title: "Industrial, Construction & Technical Project Support",
    description:
      "Practical site support for installation, inspection, maintenance and technical works in demanding environments.",
  },
  {
    title: "Contractor / Subcontractor Cooperation",
    description:
      "Flexible cooperation with contractors, subcontractors and project teams that need qualified work-at-height capability.",
  },
  {
    title: "Qualifications & Fall Protection PPE Inspection",
    description:
      "IRATA Level 2 rope access qualification, safety-conscious work preparation, and selected fall-protection PPE inspection support for work-at-height equipment.",
  },
];

const Services = () => {
  return (
    <section id="services" className="section-spacing section-muted">
      <Container>
        <Row className="mb-5">
          <Col lg={8}>
            <p className="section-kicker">Services</p>
            <h2 className="section-title">Rope access support for project teams</h2>
            <p className="lead mb-0 section-lead">
              SUPPoland supports industrial, construction and technical projects
              where safe access, practical site experience and reliable
              cooperation matter.
            </p>
          </Col>
        </Row>
        <Row className="g-4 align-items-stretch">
          {services.map((service, index) => (
            <Col md={6} key={service.title}>
              <article
                className={`info-card service-card h-100 ${
                  index === 0 ? "service-card-featured" : ""
                }`}
              >
                <span className="service-card-marker">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h3 className="h5 fw-bold">{service.title}</h3>
                <p className="mb-0">{service.description}</p>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Services;